module.exports = {
  sentryRelease: process.env.GATSBY_SENTRY_RELEASE,
};
